import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import WatermarkBannerSvg from 'assets/images/watermark-banner.svg'
import Button from 'components/ui/button'
import Header from 'components/ui/heading'
import styles from './index.module.css'

const WatermarkBanner = (): React.ReactElement<'div'> => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  return (
    <div className={styles.watermarkBanner}>
      <WatermarkBannerSvg className={styles.watermarkBannerSvg} />
      <Header size={600}>No watermarked playlists yet</Header>
      <p className={styles.watermarkBannerDescription}>
        Get started watermarking your first playlist below
      </p>
      <Button
        appearance="primary"
        caption="Watermark playlist"
        onClick={() => navigate('/watermarking/watermark-playlist')}
      />
    </div>
  )
}

export default WatermarkBanner
